<template>
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 18">
    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M21 6H1m20 1V2l-1-1H2L1 2v12l1 1h9m6 2s3-1 3-4v-2l-2-1h-2l-2 1v2c0 3 3 4 3 4Z"/>
  </svg>
</template>